import asdevInternshipImg from '../assets/png/achievements/asdev_internship.jpg'
import websiteDevImg from '../assets/png/achievements/website_development.jpg'
import ieeeSummitImg from '../assets/png/achievements/ieee_summit_2023.jpg'
import innovativeLyallpurImg from '../assets/png/achievements/innovative_lyallpur.jpg'

export const achievementData = {
    bio : "Continuous learning and real-world execution. Here are the professional milestones, certifications, and industry recognitions that validate my expertise.",
    achievements : [
        {
            id : 1,
            title : 'Front-end Developer — Professional Internship',
            details : 'Verified full tenure frontend internship at ASDEV Tech. Built responsive client-facing interfaces, reusable UI components, and modern web applications.',
            date : 'Apr 2022 – Jun 2023',
            field : 'Work Experience',
            image : asdevInternshipImg
        },
        {
            id : 2,
            title : 'Professional Web Development Certification',
            details : 'Comprehensive training in modern frontend and web technologies certified by Career Institute (affiliated with global standards).',
            date : 'Aug 15, 2022',
            field : 'Engineering Certification',
            image : websiteDevImg
        },
        {
            id : 3,
            title : 'IEEE 3rd International AI Summit',
            details : 'Recognized by IEEE ComSoc & TUF for active participation and technical engagement in Artificial Intelligence in Information & Communication.',
            date : 'IEEE Summit 2023',
            field : 'Artificial Intelligence',
            image : ieeeSummitImg
        },
        {
            id : 4,
            title : 'Innovative Lyallpur 2.0 — Tech & Innovation Showcase',
            details : 'Awarded for tech innovation, creative problem-solving, and project contribution by the Department of Computer Sciences at TUF.',
            date : 'Tech Expo 2024',
            field : 'Innovation & Tech',
            image : innovativeLyallpurImg
        }
    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/
